import { render, staticRenderFns } from "./ex-area-list.vue?vue&type=template&id=10cc16cc&scoped=true&"
import script from "./ex-area-list.vue?vue&type=script&lang=js&"
export * from "./ex-area-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-area-list.vue?vue&type=style&index=0&id=10cc16cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cc16cc",
  null
  
)

export default component.exports